export default function PreviousSearchService(userService) {
    'ngInject';

    return {
        getFormattedDate,
    };

    function getFormattedDate(date) {
        const {dateFormat, shortMonthDateFormatMoment} = userService.getRegionalSettings();
        return moment(date, dateFormat).format(shortMonthDateFormatMoment);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/previous-search/previous-search-service.js